import _ from "lodash";
import Vue from "vue";

import { findValueInSearch } from "@/stores/Utils";

export default {
  state: {
    value: [],
    options: [],
    show: true,
    clearSearchTrigger: false
  },
  getters: {
    getValue: state => state.value,
    getOptions: state => _.orderBy(state.options, ["name"], ["asc"]),
    containsValue: state => value => {
      return state.value.length > 0 ? findValueInSearch(state.value, value) : true;
    },
    show: state => state.show,
    clearSearchTrigger: state => state.clearSearchTrigger
  },
  actions: {
    reset({ commit }) {
      commit("RESET");
    },
    updateValue({ commit }, args) {
      commit("UPDATE", args);
    },
    addOptions({ commit }, args) {
      commit("ADD_OPTIONS", args);
    },
    setShow({ commit }, args) {
      commit("SET_SHOW", args);
    },
    triggerClear({ commit }) {
      commit("TRIGGER_CLEAR");
    }
  },
  mutations: {
    TRIGGER_CLEAR: state => {
      Vue.set(state, "clearSearchTrigger", !state.clearSearchTrigger);
    },
    ADD_OPTIONS: (state, payload) => {
      const newOptions = payload || [];
      const filtered = state.value.filter(el => {
        return findValueInSearch(newOptions, el);
      });

      Vue.set(state, "options", newOptions);
      Vue.set(state, "value", filtered);
    },
    RESET: state => {
      Vue.set(state, "options", []);
      Vue.set(state, "value", []);
      Vue.set(state, "show", true);
    },
    UPDATE: (state, payload) => {
      let value = []; // empty if "null"
      if (Array.isArray(payload)) {
        value = payload;
      } else if (payload) {
        value = [payload]; // array with single element
      }

      Vue.set(state, "value", value);
    },
    SET_SHOW: (state, payload) => {
      Vue.set(state, "show", payload);
    }
  },
  namespaced: true
};
